export function getProductWithLowerPrice (products) {
    if (!products) {
        return null
    }
    return sortByPrice([...products])[0]
}

function productsByPriceAsc (left, right) {
    const leftPrice = left.totalPrice.amount
    const rightPrice = right.totalPrice.amount
    return Math.sign(leftPrice - rightPrice)
}

export function sortByPrice (products) {
    return products.sort(productsByPriceAsc)
}
